module.exports = __webpack_public_path__ + "static/img/rank_background.6b58266e.png";